

import CancelBalanceTransferModal from "./CancelBalanceTransferModal";
import CancelPaymentModal from "./CancelPaymentModal";
import LostStolenModal from "./LostStolenModal";
import RedirectModal from "./RedirectModal";
import TestModal from "./TestModal";
import TurnCardOffModal from "./TurnCardOffModal";
import UpdatedCardOnFileModal from "./UpdatedCardOnFileModal";
import UnchangedCardOnFileModal from "./UnchangedCardOnFileModal";
import UnchangedCardOnFileV2Modal from "./UnchangedCardOnFileV2Modal";
import CancelUpdateMerchantModal from "./CancelUpdateMerchantModal";
import SubmitDisputeTransactionModal from "./SubmitDisputeTransactionModal";
import CancelDisputeTransactionModal from "./CancelDisputeTransactionModal";

export default {
    "TestModal" : TestModal,
    "LostStolenModal" : LostStolenModal,
    "CancelBalanceTransferModal": CancelBalanceTransferModal,
    "CancelPaymentModal": CancelPaymentModal,
    "RedirectModal" : RedirectModal,
    "TurnCardOffModal" : TurnCardOffModal,
    "UpdatedCardOnFileModal" : UpdatedCardOnFileModal,
    "UnchangedCardOnFileModal" : UnchangedCardOnFileModal,
    "UnchangedCardOnFileV2Modal": UnchangedCardOnFileV2Modal,
    "CancelUpdateMerchantModal" : CancelUpdateMerchantModal,
    "SubmitDisputeTransactionModal" : SubmitDisputeTransactionModal,
    "CancelDisputeTransactionModal" : CancelDisputeTransactionModal,
};
